import clsx from 'clsx';
import type { CSSProperties, FunctionComponent } from 'react';

export const Spinner: FunctionComponent<{ readonly className?: string; readonly style?: CSSProperties }> = ({
    className,
    style,
}) => (
    <div
        className={clsx(
            'h-[12px] w-[12px] rounded-full border-2 border-transparent border-t-current mr-xs animate-spin',
            className,
        )}
        data-testid="spinner"
        style={style}
    />
);
